import * as React from "react";
import { OrderStatusLog } from "./types";

export const OrderReceivedStatus = () => {
  return (
    <>
      <b>Order Received</b>
      <p>Did we get everything right? Please make sure:</p>
      <ul>
        <li>your recipient is in the hospital and has a room number </li>
        <li>
          you have given us the legal name of the recipient (Squeaky, Papa Joe,
          Freckles and other nicknames won&apos;t work)
        </li>
        <li>you have provided the correct Hospital</li>
        <li>you have signed your gift card message</li>
        <li>
          more info is better so if you haven&apos;t already provided a backup
          delivery address or recipient phone number, please do so.
        </li>
      </ul>
    </>
  );
};

export const OrderProcessedStatus = () => {
  return (
    <>
      <p>
        <b>In Process</b>
      </p>
      Looks like everything is moving along nicely as your order is currently
      being prepared for delivery. If there have been any changes to your
      recipients status or, if you need to update any information on your order,
      please let us know.
    </>
  );
};
export const OrderDeliveredStatus = () => {
  return (
    <>
      <p>
        <b>Delivered</b>
      </p>
      Yay! Your order has been successfully delivered. Depending on the
      facility&apos;s delivery policy your order may first be delivered to a
      designated receiving area in the hospital before being brought to the
      bedside by staff.
    </>
  );
};

export const OrderRestrictedStatus = () => {
  return (
    <>
      <p>
        <b>Recipient is in a Restricted Area</b>
      </p>
      Hospital has advised that recipient must wait for delivery until in an
      unrestricted area of the hospital. We will continue to monitor status
      within the facility and will deliver as soon as allowable.
    </>
  );
};
export const OrderRefundedStatus = () => {
  return <>A request for refund has been received by HGS.</>;
};

export const OrderCancelledStatus = () => {
  return (
    <>
      <p>
        <b>Cancelled</b>
      </p>
      Your order has been cancelled but there is still time In lieu of canceling
      you may prefer one of these alternatives:
      <ol>
        <li>
          Consider lifting the spirits of the hospital staff by donating the
          order to the Nurse&apos;s Station or floor that took care of your
          loved one.
        </li>
        <li>
          We can facilitate the order to be delivered to another needy patient
          or family member of your choice
        </li>
        <li>
          At your request we might be able to deliver the order to a new address
          near the original delivery address.
        </li>
        <li>
          We&apos;re happy to offer a Store Credit for another event in the
          future.
        </li>
      </ol>
    </>
  );
};

export const DeliveryStatusTitle = (changeType: number) => {
  if (changeType === 1) return "Order Received";
  if (changeType === 3) return "Order Processed";
  if (changeType === 0) return "Order Delivered";
  if (changeType === 5) return "Recipient is in a Restricted Area";
  if (changeType === 4) return "A request for refund has been received by HGS";
  if (changeType === 2) return "Order Cancelled";
  return "";
};

export const DeliveryStatus: React.FC<{
  StatusInfo: OrderStatusLog;
}> = (props) => {
  if (props.StatusInfo.ChangeType === 1)
    return <OrderReceivedStatus></OrderReceivedStatus>;
  if (props.StatusInfo.ChangeType === 3)
    return <OrderProcessedStatus></OrderProcessedStatus>;
  if (props.StatusInfo.ChangeType === 0)
    return <OrderDeliveredStatus></OrderDeliveredStatus>;
  if (props.StatusInfo.ChangeType === 5)
    return <OrderRestrictedStatus></OrderRestrictedStatus>;
  if (props.StatusInfo.ChangeType === 4)
    return <OrderRefundedStatus></OrderRefundedStatus>;
  if (props.StatusInfo.ChangeType === 2)
    return <OrderCancelledStatus></OrderCancelledStatus>;
  return <>{props.StatusInfo.LogMessage}</>;
};
